<template>
  <section class="content">
    <div class="container-fluid">
        <div class="row">

            <div class="col-12">
                <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Lampiran 7D</h5>
                </div>

                <!-- <form @submit.prevent="createUser"> -->

                <form @submit.prevent="createLapLamp7D()">
                    <div class="modal-body">
                        
                        <div class="form-group">
                            <label>Tanggal</label>
                            <datepicker v-model="akhir" :disabledDates="disabledAkhir" name="tgl_akhir" :format="format" placeholder="Masukkan Tanggal"></datepicker>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <!--button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button-->
                        <button type="submit" class="btn btn-success fas fa-file-excel"> Ekspor</button>
                    </div>
                  </form>
                </div>
            </div>
            </div>
        </div>
    </div>
  </section>
</template>

<script>
    import Datepicker from 'vuejs-datepicker';
    const d = new Date();
    export default {        
        data () {
            return {                
                disabledAkhir: {
                    dates:[
                        //new Date(2022, 0, 1)
                    ],
                    ranges: [{ // Disable dates in given ranges (exclusive).
                        from: new Date(),
                        to: new Date(2100, 11, 31)
                    }]
                },
                format: 'yyyy-MM-dd',
                akhir:'',
                tahun: '',
                form: new Form({
                    id : ''                    
                })
            }
        },
        methods: {            
            setDisabledDays() {                
                
            },
            createLapLamp7D(){
                let offset = this.akhir.getTimezoneOffset();
                let akhirDate = new Date(this.akhir.getTime() - (offset*60*1000));

                //let routeData = this.$router.resolve({ path: "/lamp7dxls" , query: {tahun: akhirDate.getFullYear(),akhir: akhirDate.toISOString().split('T')[0], unit_kerja:'opd'}});
                //window.open(routeData.href, '_blank');
				
				axios.get('api/lamp7dxls?tahun=' + akhirDate.getFullYear() + '&akhir=' + akhirDate.toISOString().split('T')[0] + '&unit_kerja=opd',
                        {responseType: 'blob'})
                    .then(response => {
                            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                            var fileLink = document.createElement('a');
                            fileLink.href = fileURL;
                            fileLink.setAttribute('download', 'lampiran7D-'+akhirDate.getFullYear()+'.xlsx');
                            document.body.appendChild(fileLink);
                            fileLink.click();
                        })
            }
        },
        mounted() {
            this.setDisabledDays();
            console.log('Component mounted.')
        },
        created() {
            
        },
        components: {
            Datepicker
        }
    }
</script>